(function autoCloseDetails() {
  /**
   * @param {string} selector
   */
  function closeDetails(selector) {
    document.querySelectorAll(selector).forEach((element) => element.removeAttribute('open'));
  }

  document.addEventListener('click', function (event) {
    const detailsToClose = [...document.querySelectorAll('details[data-auto-close-details][open]')].filter(
      (element) => {
        const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
        return (
          element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
          !(event.target instanceof Node && element.contains(event.target))
        );
      }
    );

    for (const detailsElement of detailsToClose) detailsElement.removeAttribute('open');
  });

  document.addEventListener('submenu-active', function () {
    closeDetails('details[data-auto-close-details-on~="submenu-active"][open]');
  });
})();
